/*
 * Based on implementation by Neil Bartlett
 * https://github.com/neilbartlett/color-temperature
 **/

import temperature2rgb from './temperature2rgb.js';
import { unpack } from '../../utils/index.js';
var round = Math.round;
var rgb2temperature = function rgb2temperature() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var rgb = unpack(args, 'rgb');
  var r = rgb[0],
    b = rgb[2];
  var minTemp = 1000;
  var maxTemp = 40000;
  var eps = 0.4;
  var temp;
  while (maxTemp - minTemp > eps) {
    temp = (maxTemp + minTemp) * 0.5;
    var _rgb = temperature2rgb(temp);
    if (_rgb[2] / _rgb[0] >= b / r) {
      maxTemp = temp;
    } else {
      minTemp = temp;
    }
  }
  return round(temp);
};
export default rgb2temperature;